import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { catchError, filter, map, Observable, of, switchMap, withLatestFrom } from 'rxjs';

import * as DataAccessPostsActions from './data-access-posts.actions';
import * as DataAccessPostsReducer from './data-access-posts.reducer';
import * as DataAccessPostsSelectors from './data-access-posts.selectors';

import { DataAccessPostsService } from '../../../services/posts/data-access-posts.service';
import * as DataAccessExhibitorsActions from '../../exhibitors/entity/data-access-exhibitors.actions';
import { DataAccessFairsFacade } from '../../fairs/entity/data-access-fairs.facade';

@Injectable()
export class DataAccessPostsEffects {
  loadPost$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataAccessPostsActions.postOpened),
      withLatestFrom(this.store.pipe(select(DataAccessPostsSelectors.getPost)), this.fairsFacade.fairId$),
      filter(([_, selectedPost, __]) => !selectedPost),
      switchMap(([action, _, fairId]) =>
        this.postsService.getPost(fairId, action.postId).pipe(
          map((post) => {
            return DataAccessPostsActions.postLoadSucceeded({
              post: post,
            });
          }),
          catchError((err) => of(DataAccessPostsActions.postLoadFailed({ error: err.status.toString() })))
        )
      )
    )
  );

  loadPostPosts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataAccessPostsActions.postLoadSucceeded),
      switchMap((action) =>
        this.postsService.getPosts(action.post.fair_id, undefined, undefined, action.post.exhibitor_id).pipe(
          map((exhibitorPostsResponse) =>
            DataAccessExhibitorsActions.exhibitorPostsLoadSucceeded({
              exhibitorPostsResponse: exhibitorPostsResponse,
              exhibitorId: action.post.exhibitor_id,
              fairId: action.post.fair_id,
            })
          ),
          catchError((err) =>
            of(
              DataAccessExhibitorsActions.exhibitorPostsLoadFailed({
                error: err.status.toString(),
                fairId: action.post.fair_id,
              })
            )
          )
        )
      )
    )
  );

  fairId$: Observable<string>;

  constructor(
    private readonly actions$: Actions,
    private store: Store<DataAccessPostsReducer.PostsState>,
    private postsService: DataAccessPostsService,
    private fairsFacade: DataAccessFairsFacade
  ) {
    this.fairId$ = this.fairsFacade.fairId$;
  }
}
